import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { theme, VStack } from '@sg/garnish';

import { useFavoriteLineItem } from '@order/features-order-status';
import { buildShareLineItemUrl } from '@order/utils';

import { type PartialLineItem } from '../../../../graphql';
import { type ReorderOrder } from '../../../../hooks';
import { useShareLineItem } from '../../../../hooks';
import { OrderStatusLineItemCard } from '../OrderStatusLineItemCard';

export const OrderStatusLineItems = (props: OrderStatusLineItemsProps) => {
  const { order, lineItems } = props;

  const { formatMessage } = useIntl();

  const { isFavoringLineItem, handleFavoriteLineItem } = useFavoriteLineItem();
  const { handleShareLineItem } = useShareLineItem();

  return (
    <VStack gap={0} hasDivider={true} dividerColor={theme.colors.LIGHT}>
      {lineItems.map((lineItem) => {
        const url = buildShareLineItemUrl(lineItem.slug);

        return (
          <OrderStatusLineItemCard
            key={lineItem.id ?? lineItem.product.name}
            lineItem={lineItem}
            order={order}
            onFavorite={handleFavoriteLineItem}
            isFetchingFavorite={isFavoringLineItem}
            isFavorite={lineItem.favorited}
            onShare={handleShareLineItem}
            shareBtnLabel={formatMessage(messages.shareProduct)}
            shareTooltipLabel={formatMessage(messages.shareProductTooltip)}
            shareUrl={url}
          />
        );
      })}
    </VStack>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  shareProduct: {
    defaultMessage: 'Share',
    description: 'Order Status | Line Items | Share Product',
  },
  shareProductTooltip: {
    defaultMessage: 'Copied link',
    description: 'Order Status | Line Items | Share Product Tooltip',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderStatusLineItemsProps = Readonly<{
  order: ReorderOrder;
  lineItems: readonly PartialLineItem[];
}>;
